/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Upload_Gate_HintInputs */

const en_case_upload_gate_hint = /** @type {(inputs: Case_Upload_Gate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a client to enable uploads.`)
};

const pt_br2_case_upload_gate_hint = /** @type {(inputs: Case_Upload_Gate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um cliente para habilitar o envio de arquivos.`)
};

/**
* | output |
* | --- |
* | "Select a client to enable uploads." |
*
* @param {Case_Upload_Gate_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_upload_gate_hint = /** @type {((inputs?: Case_Upload_Gate_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Upload_Gate_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_upload_gate_hint(inputs)
	return pt_br2_case_upload_gate_hint(inputs)
});